import type { SortByOption } from '@/shared/types/options';

import type { FilterState } from '@/entities/discovery';

/**
 * @description 탐색 관련 쿼리 키 모음
 * searchPrefix: 데이터 탐색 검색 초기화 키
 * search: 데이터 탐색 검색 키
 */

const serializeFilters = (filters?: FilterState) => {
  if (!filters) return null;
  return {
    dataSource: filters.dataSource ? [...filters.dataSource].sort() : [],
    assetType: filters.assetType ? [...filters.assetType].sort() : [],
    domain: filters.domain ? [...filters.domain].sort() : [],
    owner: filters.owner ? [...filters.owner].sort() : [],
    tier: filters.tier ? [...filters.tier].sort() : [],
    tags: filters.tags ? [...filters.tags].sort() : [],
    certification: filters.certification ? [...filters.certification].sort() : [],
    tagsOperator: filters.tagsOperator || 'OR',
    quickFilter: filters.quickFilter ? JSON.stringify(filters.quickFilter) : null,
  };
};

export const discoveryKeys = {
  all: ['discovery'] as const,

  searchPrefix: () => [...discoveryKeys.all, 'search'] as const,
  search: (query: string, sortBy: SortByOption, filters?: FilterState) =>
    [...discoveryKeys.all, 'search', query, sortBy, serializeFilters(filters)] as const,

  initialTreePrefix: () => [...discoveryKeys.all, 'initialTree'] as const,
  initialTree: () => [...discoveryKeys.initialTreePrefix()] as const,

  treeChildrenPrefix: () => [...discoveryKeys.all, 'treeChildren'] as const,
  treeChildren: (
    nodeType: string,
    index?: string,
    entityType?: string,
    serviceType?: string,
    serviceName?: string,
    databaseName?: string,
    schemaName?: string
  ) =>
    [
      ...discoveryKeys.treeChildrenPrefix(),
      nodeType,
      index,
      entityType,
      serviceType,
      serviceName,
      databaseName,
      schemaName,
    ] as const,

  entityTypeChildrenPrefix: () => [...discoveryKeys.all, 'entityTypeChildren'] as const,
  entityTypeChildren: (
    entityType: string,
    index: string,
    useAggregation: boolean,
    entityTypes?: string[],
    serviceType?: string,
    serviceName?: string,
    databaseName?: string,
    schemaName?: string
  ) =>
    [
      ...discoveryKeys.entityTypeChildrenPrefix(),
      entityType,
      index,
      useAggregation,
      JSON.stringify(entityTypes),
      serviceType,
      serviceName,
      databaseName,
      schemaName,
    ] as const,
} as const;
